<template>
  <KnowledgebaseLayout
    :categories="categories"
    :knowledgebase-path="knowledgebasePath"
    :breadcrumbs="breadcrumbs"
    :page-title="category.name"
    :search-placeholder="t.search_placeholder"
    :all-categories-label="t.all_categories"
    :active-category-id="rootCategoryId"
    :search-action="searchPath"
  >
    <template #default>
      <!-- Category Card (Single Category, Always Expanded) -->
      <div class="category-content-wrapper">
        <CategoryCard
          :category="categoryForCard"
          :expanded="true"
          :show-more-link="false"
          :translations="t"
        />
      </div>

      <!-- Pagination -->
      <div v-if="totalPages > 1" class="pagination-wrapper">
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          :total-visible="7"
          color="primary"
          class="my-4"
          @update:model-value="goToPage"
        ></v-pagination>
      </div>
    </template>
  </KnowledgebaseLayout>
</template>

<script>
import KnowledgebaseLayout from './KnowledgebaseLayout.vue'
import CategoryCard from './CategoryCard.vue'

export default {
  name: 'CategoryShowPage',
  components: {
    KnowledgebaseLayout,
    CategoryCard
  },
  props: {
    categoryData: {
      type: Object,
      default: () => ({})
    },
    categoriesData: {
      type: Array,
      default: () => []
    },
    docsData: {
      type: Array,
      default: () => []
    },
    paginationData: {
      type: Object,
      default: () => ({})
    },
    translations: {
      type: Object,
      default: () => ({})
    },
    searchPath: {
      type: String,
      default: '/result'
    },
    knowledgebasePath: {
      type: String,
      default: '/categories'
    }
  },
  data() {
    return {
      category: {},
      categories: [],
      currentPage: 1
    }
  },
  computed: {
    t() {
      return {
        search_placeholder: this.translations.search_placeholder || 'Search articles...',
        no_documents: this.translations.no_documents || 'No documents available',
        home: this.translations.home || 'Home',
        knowledgebase: this.translations.knowledgebase || 'Knowledge Base',
        all_categories: this.translations.all_categories || 'All Categories'
      }
    },
    breadcrumbs() {
      const crumbs = [
        { title: this.t.home, href: '/' },
        { title: this.t.knowledgebase, href: this.knowledgebasePath }
      ]

      if (this.category.pathArray && this.category.pathArray.length > 0) {
        this.category.pathArray.forEach(cat => {
          if (!crumbs.find(c => c.title === cat.name)) {
            crumbs.push({ title: cat.name, href: cat.path })
          }
        })
      }

      return crumbs
    },
    rootCategoryId() {
      if (this.category.pathArray && this.category.pathArray.length > 0) {
        return this.category.pathArray[0].id
      }
      return this.category.id
    },
    categoryForCard() {
      return {
        id: this.category.id,
        name: this.category.name,
        icon: this.category.icon,
        path: this.category.path,
        docs: this.docsData,
        children: this.category.children || []
      }
    },
    totalPages() {
      return this.paginationData.total_pages || 1
    }
  },
  mounted() {
    this.category = this.categoryData || {}
    this.categories = this.categoriesData || []
    this.currentPage = this.paginationData.current_page || 1
  },
  methods: {
    goToPage(page) {
      const url = new URL(window.location)
      url.searchParams.set('page', page)
      window.location = url.toString()
    }
  }
}
</script>

<style scoped>
.category-content-wrapper {
  padding: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
</style>
